var map = {
	"./amex.png": 932,
	"./diners.png": 933,
	"./discover.png": 934,
	"./jcb.png": 935,
	"./maestro.png": 1158,
	"./mastercard.png": 936,
	"./stripe.png": 937,
	"./union.png": 938,
	"./unknown.png": 618,
	"./visa.png": 939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1157;